import * as Schema from "effect/Schema";

export const TRANSCRIPTIONS_ROUTE_PATH = "/transcriptions";
export const VOICE_TRANSCRIPTION_MAX_BYTES = 25 * 1024 * 1024;

export const TranscriptionResponse = Schema.Struct({
  text: Schema.String,
});
export type TranscriptionResponse = typeof TranscriptionResponse.Type;
